import { NoAccessPage } from '@mysaiva/core'
import { useTranslation } from 'react-i18next'
import { SaivaProduct } from '../utils/productRedirect'

const PRODUCT_DISPLAY_NAMES: Record<SaivaProduct, string> = {
  [SaivaProduct.Upt]: 'UPT',
  [SaivaProduct.WoundCare]: 'Capture',
  [SaivaProduct.Therapy]: 'Therapy',
  [SaivaProduct.Compass]: 'Compass'
}

interface UnauthorizedProductScreenProps {
  /** Product the user tried to open; omit for a generic message */
  product?: SaivaProduct
}

/**
 * Screen shown when user tries to access a product they don't have permission for.
 *
 * SAIV-11238: this is an authorization outcome, not an application failure,
 * so it renders "Access denied" with next steps rather than the generic
 * "Oops" ErrorPage (which stays reserved for real failures).
 */
export function UnauthorizedProductScreen({ product }: UnauthorizedProductScreenProps) {
  const { t } = useTranslation()
  const productName = product
    ? PRODUCT_DISPLAY_NAMES[product]
    : t('errors.accessDenied.thisApplication')

  return (
    <NoAccessPage
      title={t('errors.accessDenied.title')}
      message={`${t('errors.accessDenied.message', { productName })} ${t('errors.accessDenied.contactAdmin')}`}
      buttonLabel={t('errors.accessDenied.goHome')}
    />
  )
}
